import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Accredible|Accredible Data|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	feature: HubFeature.ShareAccredibleBadging,
	htmlAllowed: false,
	portal: 'SP',
};

type LocNameStart = 'SPToolsAccredibleData';
export type SPToolsAccredibleDataLocNames =
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}TitleTable`
	| `${LocNameStart}LabelEmail`
	| `${LocNameStart}LabelCandidateName`
	| `${LocNameStart}LabelGroupName`
	| `${LocNameStart}LabelGroupId`
	| `${LocNameStart}LabelActiveDate`
	| `${LocNameStart}LabelExpireDate`;

export const spToolsAccredibleDataLocs: LocDefs<SPToolsAccredibleDataLocNames> = {
	SPToolsAccredibleDataTitleSection: {
		defaultValue: 'Accredible Data',
		description: 'Section Title',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.Title.AccredibleDataSection',
		...sharedProperties,
	},
	SPToolsAccredibleDataTitleTable: {
		defaultValue: 'Accredible Data',
		description: 'Table Title',
		displayPath: `${pathStart}Table Title`,
		displayType: 'Title',
		legacyName:
			'Share.AccredibleBadging/Accredible.BadgeSearch.PageSectionTitle.AccredibleData',
		...sharedProperties,
	},
	SPToolsAccredibleDataLabelEmail: {
		defaultValue: 'Email',
		description: 'Column heading for: Email.',
		displayPath: `${pathStart}Email`,
		displayType: 'Label',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearchDuplicates.ColumnHeading.Email',
		...sharedProperties,
	},
	SPToolsAccredibleDataLabelCandidateName: {
		defaultValue: 'Candidate Name',
		description: 'Column heading for: Candidate Name.',
		displayPath: `${pathStart}Candidate Name`,
		displayType: 'Label',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.ColumnHeading.CandidateName',
		...sharedProperties,
	},
	SPToolsAccredibleDataLabelGroupName: {
		defaultValue: 'Group Name',
		description: 'Column heading for: Group Name.',
		displayPath: `${pathStart}Group Name`,
		displayType: 'Label',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.ColumnHeading.GroupName',
		...sharedProperties,
	},
	SPToolsAccredibleDataLabelGroupId: {
		defaultValue: 'Group ID',
		description: 'Column heading for: Group ID.',
		displayPath: `${pathStart}Group ID`,
		displayType: 'Label',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.ColumnHeading.GroupId',
		...sharedProperties,
	},
	SPToolsAccredibleDataLabelActiveDate: {
		defaultValue: 'Active Date',
		description: 'Column heading for: Active Date.',
		displayPath: `${pathStart}Active Date`,
		displayType: 'Label',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.ColumnHeading.ActiveDate',
		...sharedProperties,
	},
	SPToolsAccredibleDataLabelExpireDate: {
		defaultValue: 'Expire Date',
		description: 'Column heading for: Expire Date.',
		displayPath: `${pathStart}Expire Date`,
		displayType: 'Label',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.ColumnHeading.ExpireDate',
		...sharedProperties,
	},
};

export type SPToolsAccredibleDataLocType = LocMap<SPToolsAccredibleDataLocNames>;
